import React from "react";
import { Box, Button, Checkbox, FormControlLabel, Grid, makeStyles } from "@material-ui/core";
import ActionDialog from "../ActionDialog";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  containerTitle: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
}));

const DialogColumnSelector = ({ open, onClose, availableColumns, selectedColumns, onChange, title = "app.column.filter" }) => {
  const classes = useStyles();
  const [localSelection, setLocalSelection] = React.useState(selectedColumns);

  React.useEffect(() => {
    setLocalSelection(selectedColumns);
  }, [selectedColumns]);

  const handleToggle = (name) => {
    setLocalSelection((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const handleSelectAll = () => {
    const newValue = {};
    availableColumns.forEach((col) => {
      newValue[col.name] = true;
    });
    setLocalSelection(newValue);
  };

  const handleDeselectAll = () => {
    const newValue = {};
    availableColumns.forEach((col) => {
      newValue[col.name] = false;
    });
    setLocalSelection(newValue);
  };

  const handleSave = () => {
    if (onChange) onChange(localSelection);
    onClose();
  };

  return (
    <>
      <ActionDialog
        open={open}
        onClose={onClose}
        onAccept={handleSave}
        title={title}
        textConfirm="app.button.save"
        maxWidth="xs"
      >
        <Box className={classes.containerTitle}>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleSelectAll}
            size="small"
          >
            <FormattedMessage id="app.columns.selectAll" />
          </Button>

          <Button
            variant="outlined"
            size="small"
            onClick={handleDeselectAll}
          >
            <FormattedMessage id="app.columns.deselectAll" />
          </Button>
        </Box>
        <Grid
          container
          spacing={1}
        >
          {availableColumns.map((col) => (
            <Grid
              item
              xs={6}
              key={col.name}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!localSelection[col.name]}
                    onChange={() => handleToggle(col.name)}
                    color="primary"
                  />
                }
                label={<FormattedMessage id={col.label} />}
              />
            </Grid>
          ))}
        </Grid>
      </ActionDialog>
    </>
  );
};

export default React.memo(DialogColumnSelector);
